
// Armor Traits
export const armorMetadata = [
  { name: 'Yn', description: 'Lorem Ipsum' },
  { name: 'Tagen', description: 'Lorem Ipsum' },
  { name: 'Salus', description: 'Lorem Ipsum' },
  { name: 'Areb', description: 'Lorem Ipsum' },
  { name: 'Penta', description: 'Lorem Ipsum' },
  { name: 'Xut', description: 'Lorem Ipsum' },
  { name: 'Tessen', description: 'Lorem Ipsum' },
  { name: 'Zyad', description: 'Lorem Ipsum' },
  { name: 'Sagen', description: 'Lorem Ipsum' },
  { name: 'Deka', description: 'Lorem Ipsum' }
];

// Colors Traits
export const colorInventory = [
  { primary: 0x919191, primaryName: 'Silver', secondary: 0x919191, secondaryName: 'Silver', neon: 0x005DFF, neonName: 'Blue Neon' },
  { primary: 0xC4933F, primaryName: 'Golden', secondary: 0xC4933F, secondaryName: 'Golden', neon: 0x21FE00, neonName: 'Green Neon' },
  { primary: 0x3D3F40, primaryName: 'Graphite', secondary: 0xE07509, secondaryName: 'Orange', neon: 0x00E4FF, neonName: 'Light Blue Neon' },
  { primary: 0x7A6B4C, primaryName: 'Desert Sand', secondary: 0xEDDFCE, secondaryName: 'Perel White', neon: 0x68FFB7, neonName: 'Light Green Neon' },
  { primary: 0x46482E, primaryName: 'Army Green', secondary: 0xFFC403, secondaryName: 'Yellow', neon: 0xFF5601, neonName: 'Orange Neon' },
  { primary: 0x026755, primaryName: 'Alfa Green', secondary: 0xFF005E, secondaryName: 'Pink', neon: 0xFE00D4, neonName: 'Pink Neon' },
  { primary: 0x369E09, primaryName: 'Grass Green', secondary: 0x7B00A1, secondaryName: 'Violet', neon: 0xFF1900, neonName: 'Red Neon' },
  { primary: 0x3C09D6, primaryName: 'Deep Blue', secondary: 0x0389A3, secondaryName: 'Blue', neon: 0x7F00FF, neonName: 'Violet Neon' },
  { primary: 0x230054, primaryName: 'Dark Violet', secondary: 0x0AE385, secondaryName: 'Light Green', neon: 0xFFAE00, neonName: 'Yellow Neon' },
  { primary: 0x660000, primaryName: 'Blood Red', secondary: 0xA7E302, secondaryName: 'Aquamarine', neon: 0xE7FE00, neonName: 'Yellow/Green Neon' }
];

// Performance Traits
export const surfaceInventory = ['Rubber', 'Asphalt', 'Rocky', 'Mud', 'Dirt', 'Snow', 'Sand', 'Neon', 'Metallic', 'Essence'];
export const distanceInventory = ['600m', '800m', '1000m', '1200m', '1400m', '1600m', '1800m', '2000m'
, '2200m', '2500m'];
export const weatherInventory = ['Sunny', 'Foggy', 'Dusty', 'Rainy', 'Eclipse', 'Blue Moon', ' Etherwind', 'Vulcanic', 'Void', 'Storm'];

/*
1. Blue- 0389A3
2. Orange- E07509
3. Deap Blue- 3C09D6
4. Light Green- 0AE385
5. Aquamarine- A7E302
6. Yellow- FFC403
7. Pink- FF005E
8. Violet- 7B00A1
9. Dark Green- 006134
10. Silver- 919191*/